import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";
import { useNavigate } from "react-router";
import { useApplicationId } from "../../hooks/useApplicationId";
import { useSteps } from "../../hooks/useSteps";
import { useCreditScoreMutation, useDeleteApplicationMutation } from "../../services/application";
import { stepIs } from "../../utils/application";

type Props = {
	open: boolean;
};

const MissingCreditAssessment = ({ open }: Props) => {
	const [t, texts] = useText();
	const [creditScoreMutation, { isLoading: isLoadingCreditScore }] = useCreditScoreMutation();
	const [deleteApplicationMutation, { isLoading: isDeletingApplication }] =
		useDeleteApplicationMutation();
	const { steps } = useSteps();
	const applicationId = useApplicationId();
	const navigate = useNavigate();
	const orgNr = steps?.find(stepIs("InitiateStep"))?.state.orgNr;

	if (!orgNr) {
		return;
	}

	return (
		<Dialog
			isDismissable={false}
			isOpen={open}
			size="small"
			heading={t(texts.modals.missingCreditAssessment.heading)}
		>
			<Dialog.Content>{t(texts.modals.missingCreditAssessment.body)}</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button
						width="full"
						onPress={() => creditScoreMutation({ applicationId, orgNr })}
						isPending={isLoadingCreditScore}
					>
						{t(texts.modals.missingCreditAssessment.confirmButton)}
					</Button>
					<Button
						width="full"
						variant="secondary"
						onPress={async () => {
							await deleteApplicationMutation(applicationId);
							navigate("/dashboard");
						}}
						isPending={isDeletingApplication}
					>
						{t(texts.common.abort)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default MissingCreditAssessment;
